import { ReaderTitle } from '../Components/ReaderPage/ReaderTitle/ReaderTitle.jsx';

export default function CollectivePage() {
    return (
        <main>
            <ReaderTitle></ReaderTitle>
        </main>
    )
}